import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from '../firebase';

export const addNewItem = async (section, data) => {
  const collectionName = section === 'faq' ? 'faqs' : section === 'utterance' ? 'utterances' : 'answers';
  try {
    await addDoc(collection(db, collectionName), {
      ...data,
      addedAt: serverTimestamp()
    });
  } catch (error) {
    console.error(`Error adding ${section}:`, error);
    throw error;
  }
};
